<template>
  <div
    class="product-card"
    :data-product-id="isHideBlockParams ? '' : product?.id"
    :data-product-slug="isHideBlockParams ? '' : product?.slug"
    :data-product-page="isHideBlockParams ? '' : currentPage"

    @click="addEcommerce('click',product as IProduct)"
  >
    <div class="product-item ">
      <div class="product-item__image">
        <nuxt-img
          loading="lazy"
          width="250"
          height="255"
          :src="String(product?.imageId)"
          fit="contain"
          alt="img"
        />
      </div>
      <div class="product-item__information">
        <div
          v-html="product?.name"
          class="product-item__name"
        />
        <div class="product-item__prices">
          <div class="product-item__prices-currency">
            {{ $priceFormat({amount:product?.price, decimalCount:0 }) }} ₽
          </div>
          <div
            v-if="product.oldPrice"
            class="product-item__prices-old"
          >
            {{ $priceFormat({amount: product?.oldPrice, decimalCount:0 }) }} ₽
          </div>
        </div>
      </div>
      <nuxt-link
        :to="product?.url"
        class="product-item__link"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IProduct } from '#sitis/internal/controllers/products/models/Product';
import { useNuxtApp } from '#app';
import useEcommerce from '~/composables/useEcommerceYandex';

const { addEcommerce } = useEcommerce();
const { $priceFormat } = useNuxtApp();
const { product, page = 1, isHideBlockParams = false } = defineProps <{
    product:IProduct;
    page?:number|undefined|string;
    isHideBlockParams?:boolean;
  }>();

const currentPage = ref<number|undefined|string>('');
currentPage.value = page;

</script>

<style scoped lang="scss">

.product-card {
}

.product-item {
  cursor: pointer;
  padding: 15px;
  position: relative;
  height: 100%;
  transition: all linear .2s;

  &:hover {
    box-shadow: 0 0 5px 0 #0000005e;
    border-radius: 3px;
    transition: all linear .2s;
  }
}

.product-item__image {
  overflow: hidden;
  white-space: nowrap;
  height: 255px;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;

  & > img {
    object-fit: contain;
  }
}

.product-item__information {
  display: flex;
  justify-content: space-between;

}

.product-item__name {
  color: #000;
  display: block;
  font-size: 18px;
  letter-spacing: .1px;
  text-decoration: none;
  padding-right: 8px;
  line-height: 1.15;
}

.product-item__prices {
  display: flex;
  flex-direction: column;
}

.product-item__prices-currency {
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #000;
  white-space: nowrap;
}

.product-item__prices-old {
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  text-decoration-line: line-through;
  color: #979797;
  white-space: nowrap;
}

.product-item__link {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
</style>
<style lang="scss">
.product-item__name {
  b, strong {
    font-weight: 600;
  }
}
</style>
